import React, { useState, useEffect } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import { debug, LogD } from '../../../function/LogLapper';
import dayjs from 'dayjs';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    tableTd: {
      fontSize: '15px',
    },
    textField: {
      width: 200,
    },
    //style for font size
    resize: {
      fontSize: '15px',
    },
  })
);

type Props = {
  labelCssString?: string;
  textCssString?: string;
  label: string;
  labelPosition?: number;
  defaultValue: string;
  onChange: (value: string) => void;
  marginString?: string;
};

/**
 * カレンダーに時刻を追加したコンポーネント
 * @param props
 * @returns
 */
const ItemCalenderTime: React.FC<Props> = (props) => {
  const { labelPosition = 1 } = props;
  const classes = useStyles();

  //console.debug(['- ItemCalenderTime props -', props]);

  /**
   * 時刻を　yyyy-MM-ddThh:mm　フォーマットで返す
   * @param value
   * @returns
   */
  const convertDatetimeLocalFormat = (value: string) => {
    const timeStr = dayjs(value).format('YYYY-MM-DDTHH:mm');
    //console.debug(['convertDatetimeLocalFormat', value, timeStr]);
    return timeStr;
  };

  const [editValue, setEditValue] = useState<string>(props.defaultValue);
  useEffect(() => {
    setEditValue(props.defaultValue);
  }, [props.defaultValue]);

  return (
    <Box component="span" display="inline-flex" alignItems="center">
      {labelPosition === 1 && <div className={props.labelCssString ?? classes.tableTd}> {props.label}</div>}
      <form className={classes.container} noValidate>
        <TextField
          id="date"
          type="datetime-local"
          InputProps={{
            classes: {
              input: props.textCssString ?? classes.resize,
            },
          }}
          defaultValue={props.defaultValue}
          value={convertDatetimeLocalFormat(editValue)}
          onChange={(event) => {
            console.debug(['-- onChange --', event.target.value]);
            if (event.target.value !== '') {
              setEditValue(dayjs(event.target.value).format('YYYY-MM-DD HH:mm'));
              //              props.onChange(dayjs(event.target.value).format('YYYY-MM-DD HH:mm'));
            }
          }}
          className={classes.textField}
          onBlur={(e) => {
            console.log('datetime blur', editValue);
            props.onChange(dayjs(editValue).format('YYYY-MM-DD HH:mm'));
          }}
        />
      </form>
      {labelPosition === 2 && <div className={props.labelCssString ?? classes.tableTd}> {props.label}</div>}
    </Box>
  );
};
export default ItemCalenderTime;
